export enum IdResidence {
  Italian = '1',
  Foreign = '2',
  NotKnown = '3',
}
